import React from "react";

const Svg = ({width = 17}: {width?: number} = {}) => {
  const w = 17;
  const h = 15;
  const height = (width / w) * h;

  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 17 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M1 1H15.5"
        stroke="#0F000C"
        strokeWidth="1"
        strokeLinecap="round"
      />
      <path
        d="M1 7.54834H15.5"
        stroke="#0F000C"
        strokeWidth="1"
        strokeLinecap="round"
      />
      <path
        d="M1 13.5H15.5"
        stroke="#0F000C"
        strokeWidth="1"
        strokeLinecap="round"
      />
    </svg>
  );
};
export default Svg;
